<template>
  <settings-modal class="card-block-modal">
    <template slot="heading">{{ heading }}</template>

    <p>After blocking all <b>card functions will be permanently disabled</b>. Card holder won’t be able
    to pay or withdraw funds via this card as well as reissue or add additional cards.</p>

    <v-select
      v-model="form.reason"
      :items="reasonOptions"
      class="t-reason-field"
      label="Select reason"
      item-text="reason"
      item-value="id"
      return-object
      :error-messages="getValidationErrorMessage('reason')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-block-card"
        color="primary"
        medium
        flat
        :disabled="isActionButtonDisabled"
        @click="blockCard"
      >{{ actionButtonText }}</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="closeModal"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_CARD_UPDATE } from '@/events/cards'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CardBlockModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { reason: null },
        freezeCardApiRequest: new ApiRequest(IssuingApi.freezeCard)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      cardId () {
        return this.modal.data.cardId
      },
      heading () {
        return this.modal.data.heading
      },
      actionButtonText () {
        return this.modal.data.buttonText
      },
      reasonOptions () {
        return this.modal.data.reasonOptions
      },
      successMessage () {
        return this.modal.data.successMessage
      },
      isActionButtonDisabled () {
        return this.freezeCardApiRequest.loading || this.form.reason == null
      },
      error () {
        return this.freezeCardApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      blockCard () {
        this.freezeCardApiRequest
          .execute(this.cardId, this.form.reason)
          .then(this.onCardBlockSuccess)
          .catch(() => {})
      },
      onCardBlockSuccess () {
        this.$eventHub.$emit(EVENT_CARD_UPDATE)

        this.showModal({
          name: 'SuccessFlashModal',
          data: { message: this.successMessage }
        })
      }
    }
  }
</script>
